import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

import * as GuiasCompraService from 'services/guiasCompra.service'

const portletBreadcrumbs = [{ name: 'Ingreso Guias - Compras' }]

const ListaComprasPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const clickNuevoHandler = e => {
    e.preventDefault()
    history.push(`/${CodigosTransaccionesConstant.COMPRASINGRESOGUIA_NUEVO}`)
  }

  const clickEditarHandler = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.COMPRASINGRESOGUIA_EDITAR}/${_id}`)
    },
    [history]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      GuiasCompraService.eliminarGuia(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado!')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Ingreso Guias - Compras' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevoHandler }]} />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            url='/api/guias-compra'
            useFilters={true}
            
            headRows={[
              { label: 'FECHA', width: 85, align: 'center' },
              {
                label: 'TIPO',
                width: 90,
                align: 'center'
              },
              {
                label: 'SERIE DOC',
                width: 105,
                align: 'center',
                filter: {
                  type: 'text',
                  name: 'serDoc'
                }
              },
              {
                label: 'NUM DOC',
                width: 105,
                align: 'center',
                filter: {
                  type: 'text',
                  name: 'numDoc'
                }
              },
              {
                label: 'RUC',
                width: 100,
                align: 'center'
              },
              { label: 'RAZÓN SOCIAL', align: 'center' },
              { label: '', width: 30, align: 'center' }
            ]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell>{row.tipoDocumento ? TiposDeDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}</Table.Cell>
                <Table.Cell>{`${row.serieDocumento} `}</Table.Cell>
                <Table.Cell>{` ${row.numeroDocumento}`}</Table.Cell>
                <Table.Cell>{row.documentoSocio || '--'}</Table.Cell>
                <Table.Cell>{row.nombreSocio || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditarHandler({ _id: row._id })}>
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default ListaComprasPage
